import axios, { AxiosRequestConfig, AxiosError, CancelTokenSource, AxiosResponse } from "axios";

export interface IFetcher {
    fetch: AxiosResponse<any> | AxiosError<any> | string;
    cancel: () => void;
}

const axiosAPIInstanceSGA = axios.create({
    baseURL: `${process.env.REACT_APP_SERVER}`,
});

const axiosAPIInstanceITS = axios.create({
    baseURL: `${process.env.REACT_APP_LOCAL_SERVER}`,
});

export const STATUS_OK = 200;
export const STATUS_CREATED = 201;
export const NOT_FOUND = 404;

const fetcher = async (args: AxiosRequestConfig): Promise<IFetcher | undefined> => {
    const source: CancelTokenSource = axios.CancelToken.source();

    try {
        const response = await axiosAPIInstanceSGA({
            ...args,
            cancelToken: source.token,
        });

        return {
            fetch: response,
            cancel: () => source.cancel("Solicitud cancelada"),
        };
    } catch (error: any) {
        if (axios.isCancel(error)) {
            console.log("La petición fue cancelada:", error.message);
        } else {
            const axiosError = error as AxiosError;
            if (axiosError.response && axiosError.response.status === 401) {
                console.log("Cerrando sesión!");
            }
            return { fetch: (axiosError.response ?? axiosError.request) || axiosError.message, cancel: () => { } };
        }
    }
    throw new Error("Unexpected code execution");
};

export const fetcherIts = async (args: AxiosRequestConfig): Promise<IFetcher | undefined> => {
    const source: CancelTokenSource = axios.CancelToken.source();
    try {
        const response = await axiosAPIInstanceITS({
            ...args,
            cancelToken: source.token,
        });

        return {
            fetch: response,
            cancel: () => source.cancel("Solicitud cancelada"),
        };
    } catch (error: any) {
        if (axios.isCancel(error)) {
            console.log("La petición fue cancelada:", error.message);
        } else {
            const axiosError = error as AxiosError;
            if (axiosError.response && axiosError.response.status === 401) {
                console.log("Cerrando sesión!");
            }
            return { fetch: (axiosError.response ?? axiosError.request) || axiosError.message, cancel: () => { } };
        }
    }
}

export default fetcher;